/*
 * @Author: tao_yang
 * @Date: 2022-05-05 18:04:07
 * @LastEditors: tao_yang
 * @LastEditTime: 2023-02-16 18:03:04
 * @Description: 装修方案list卡片
 */
import './index.scss';
export default function HouseTypeCardDecoration(props) {
    const HOUSE_TYPE = [
        intl.get('projectSpace.room'),
        intl.get('projectSpace.living'),
        intl.get('projectSpace.rest'),
        intl.get('decorationDesign.kitchen'),
    ];

    return (
        <div className="house-type-card-decoration">
            {/* <Image
                className={`ht-card-image ${props.showPreview && 'pointer'}`}
                preview={false}
                onClick={() => props.titleClickHandler?.()}
                src={props.image}
            /> */}
            <div
                className="img-wrap"
                style={{ backgroundImage: `url(${props.image})` }}></div>
            <div className="ht-card-footer">
                <div
                    className={`ht-card-meta ${
                        props.titleClickHandler ? 'pointer' : ''
                    }`}
                    onClick={() => props.titleClickHandler?.()}>
                    <div className="ht-card-meta-title">{props.title}</div>
                    <div
                        className="ht-card-subtitle"
                        style={{ color: 'rgba(0, 0, 0, 0.4)' }}>
                        {intl.get('decorationDesign.planArea')}
                        {props.houseType
                            .map((v, index) => v + HOUSE_TYPE[index])
                            .join('')}{' '}
                        {props.inner}m²
                    </div>
                    {props.appendMeta}
                </div>
                <div className="ht-view-operation">{props.render?.()}</div>
            </div>
        </div>
    );
}
